import Card from '@mui/material/Card';
import { FileAttachableType } from '@treadinc/horizon-api-spec';
import type { JSX } from 'react';
import { useFormContext } from 'react-hook-form';

import FileAttachments from '~formsShared/components/FileAttachments';

import {
  type OrderFormV3FieldValues,
  useOrderFormV3Context,
} from '../OrderFormV3Context';

/**
 * Renders order file attachments. Render-only: the legacy title-less card
 * around the embedded legacy FileAttachments, wired 1:1 (no fork; the
 * widget is the canonical implementation shared by Projects, Orders, Jobs
 * and Loads). The embed owns the upload/update/delete queues behind its
 * imperative handle; `ref={fileAttachmentsRef}` (context-owned, mirroring
 * legacy's own ref) is how the shell's `fileAttachmentsOnSubmit` /
 * `fileAttachmentsOnClose` methods flush those queues at save/close time —
 * without the shared ref, attachments added during the session are never
 * uploaded or rolled back.
 */
export function FileAttachmentsPanel(): JSX.Element {
  const { defaultOrder, fileAttachmentsRef } = useOrderFormV3Context();
  const formMethods = useFormContext<OrderFormV3FieldValues>();
  const {
    control,
    formState: { errors },
  } = formMethods;

  return (
    <Card sx={{ p: 2, mb: 2 }}>
      <FileAttachments
        fileAttachableId={defaultOrder?.id}
        fileAttachableType={FileAttachableType.ORDER}
        control={control}
        errors={errors}
        form={formMethods}
        name="fileAttachments"
        ref={fileAttachmentsRef}
      />
    </Card>
  );
}
